import { Dispatch, FC, JSX, SetStateAction } from 'react';

import { Button, Form, FormListFieldData, Table } from 'antd';
import { ColumnProps } from 'antd/es/table';

import styles from './DebtsDesktopTable.module.scss';

import { BusinessDebtDto } from '@/generated-types';
import { getFormattedAmount } from '@/utils';

type TDebtsDesktopTableProps = {
	columns: ColumnProps<FormListFieldData>[];
	fields: FormListFieldData[];
	add: () => void;
	setEditingRowId: Dispatch<SetStateAction<number>>;
};

export const DebtsDesktopTable: FC<TDebtsDesktopTableProps> = ({
	columns,
	fields,
	add,
	setEditingRowId,
}): JSX.Element => {
	const form = Form.useFormInstance();
	const businessDebts = Form.useWatch('businessDebts', form) || [];

	return (
		<>
			<Table
				columns={columns}
				dataSource={fields}
				pagination={false}
				rowKey={'name'}
				scroll={{ x: true }}
				summary={() => {
					const totalCurrentDebtBalance = businessDebts.reduce(
						(sum: number, row: BusinessDebtDto) => sum + (Number(row?.outstandingBalance) || 0),
						0,
					);
					const totalMonthlyPayment = businessDebts.reduce(
						(sum: number, row: BusinessDebtDto) => sum + (Number(row?.regularPayment) || 0),
						0,
					);

					const totalFormattedCurrentDebtBalance = getFormattedAmount(totalCurrentDebtBalance);
					const totalFormattedMonthlyPayment = getFormattedAmount(totalMonthlyPayment);

					return (
						<Table.Summary.Row>
							<Table.Summary.Cell colSpan={5} index={0}>
								<div style={{ textAlign: 'right' }}>Total:</div>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={5}>
								<div style={{ textAlign: 'left' }}>{totalFormattedCurrentDebtBalance}</div>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={6}>
								<div style={{ textAlign: 'left' }}>{totalFormattedMonthlyPayment}</div>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={7} />
							<Table.Summary.Cell index={8} />
							<Table.Summary.Cell index={9} />
						</Table.Summary.Row>
					);
				}}
				onRow={(record) => ({
					onClick: () => setEditingRowId(record.name),
				})}
			/>
			<Button className={styles['add-debt-button']} type="primary" onClick={() => add()}>
				Add Debt
			</Button>
		</>
	);
};
